import { createOrUpdate, regenSlug } from '../../../services/lwadmin/category/category-service';

export default class Category {
  constructor(source) {
    Object.assign(this, source || {
      id: null,
      name: '',
      description: '',
      slug: '',
      stats: {
        wires_count: 0,
      },
    });
  }

  save() {
    return createOrUpdate(this);
  }

  regenerateSlug() {
    return regenSlug(this.id);
  }
}
